<div *ngIf="items">
  <div *ngIf="(options.showPageLinks !== false) && items.totalPages > 1">
    <nav aria-label="Page navigation example">
      <ul
        style="position: absolute; right: 30px; padding: 5px"
        class="pagination"
        [class.pagination-lg]="options.large"
        [class.pagination-sm]="options.small"
      >
        <li
          *ngFor="let page of pages"
          class="page-item"
          [class.active]="page.active"
          [class.disabled]="page.disabled"
          [ngSwitch]="page.active"
        >
          <a class="page-link" *ngSwitchCase="true"> {{page.text}}</a>
          <a
            class="page-link"
            href="#"
            *ngSwitchDefault
            (click)="selectPage(page.pageNumber, $event)"
          >
            {{ page.text }}
          </a>
        </li>
        <div *ngIf="options.showPagingSummary">
          <div *ngIf="items.totalCount > 0" style="color: black; padding: 5px">
            Showing [{{ items.pageStartingIndex }} - {{ items.pageEndingIndex}}] of
            <span class="text-primary h5">{{ items.totalCount }}</span> | Page {{ items.pageIndex }}
            of {{ items.totalPages }}
          </div>
        </div>
      </ul>
    </nav>
  </div>
</div>
